export const windDirectionsSpanish = [
    { label: 'Calma', value: 'CALMA' },
    { label: 'Norte', value: 'N' },
    { label: 'Noroeste', value: 'NW' },
    { label: 'Oeste', value: 'W' },
    { label: 'Suroeste', value: 'SW' },
    { label: 'Sur', value: 'S' },
    { label: 'Sureste', value: 'SE' },
    { label: 'Este', value: 'E' },
    { label: 'Noreste', value: 'NE' },
]

export const visibilitySelector = [
    { label: '0%', value: '0' },
    { label: '25%', value: '25' },
    { label: '50%', value: '50' },
    { label: '75%', value: '75' },
    { label: '100%', value: '100' },
]

export const windSpeed = [
    { label: '0 - CALMA', value: '0' },
    { label: '1 - BRISA', value: '1' },
    { label: '2 - MODERADO', value: '2' },
    { label: '3 - FUERTE', value: '3' },
    { label: '4 - MUY FUERTE', value: '4' },
]

export const cloudCover = [
    { label: '0%', value: '0' },
    { label: '25%', value: '25' },
    { label: '50%', value: '50' },
    { label: '75%', value: '75' },
    { label: '100%', value: '100' },
]

export const age = [
    { label: '0 - Desconocido', value: '0' },
    { label: '1 - Joven', value: '1' },
    { label: '2 - Inmaduro - Subadulto', value: '2' },
    { label: '3 - Adulto', value: '3' },
]

export const altitudeLevel = [
    { label: '1 - Por debajo de las palas', value: '1' },
    { label: '2 - A la altura de las palas', value: '2' },
    { label: '3 - Por encima de las palas', value: '3' },
    { label: '4 - Muy por encima de las palas', value: '4' },
]

export const aeroStatus = [
    { label: 'Encendido', value: 'encendido' },
    { label: 'Apagado', value: 'apagado' },
]

export const distanceToAero = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
]

export const flightType = [
    { label: 'Campeo', value: 'campeo' },
    { label: 'Cicleo', value: 'cicleo' },
    { label: 'Directo', value: 'directo' },
]

export const Months = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 },
]

export const sex = [
    { label: '0 - Desconocido', value: '0' },
    { label: '1 - Macho', value: '1' },
    { label: '2 - Hembra', value: '2' },
]

export const stateSpecies = [
    { label: 'Muerto', value: 'M' },
    { label: 'Herido', value: 'H' },
]

export const yesNoSelector = [
    { label: 'Si', value: 'yes' },
    { label: 'No', value: 'no' },
]

export const appSelectors = [
    { label: 'Si', value: 'yes' },
    { label: 'No', value: 'no' },
    { label: 'Parcial', value: 'partial' },
]

export const carrionPresentSelector = [
    { label: 'No', value: 'no' },
    { label: 'Sí', value: 'yes' },
]

export const carrionStopPresentSelector = [
    { label: 'No', value: 'no' },
    { label: 'Sí, dentro del parque', value: 'yes' },
    { label: 'Sí, fuera del parque', value: 'yes_out' },
]

export const speciesGroupSelector = [
    { label: 'Rapaces y planeadoras', value: 'raptors_and_gliders' },
    { label: 'Otras aves grandes y medianas', value: 'other_big_and_medium' },
    { label: 'Paseriformes y otras', value: 'passeriformes_and_other' },
    { label: 'Quirópteros', value: 'quipeters' },
    { label: 'Carroñas', value: 'carrions' },
    { label: 'No designada', value: 'no_designated' },
]


//----------------------------------------------------------------------------------------------------------------------------
/**
 * @EN OPTIONS TO SELECT TYPES
 * @ES OPCIONES PARA SELECCIONAR TIPOS
 * 
 */
//----------------------------------------------------------------------------------------------------------------------------
export const categoryOptions = [
    // { label: 'Informe de carroñas', value: 'carrion' },
    // { label: 'Informe de censos', value: 'census' },
    // { label: 'Informe de especies', value: 'species' },
    { label: 'Informe de incidencias', value: 'issues' },
    { label: 'Informe de paradas', value: 'stops' },
    { label: 'Informe de Paradas e Incidencias', value: 'stops_issues' },
]
//----------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------
/**
 * @EN OPTIONS TO RISK LEVEL
 * @ES OPCIONES PARA NIVEL DE RIESGO
 */
//----------------------------------------------------------------------------------------------------------------------------
export const riskLevelOptions = [
    { label: 'EN', value: 'EN' },
    { label: 'VU', value: 'VU' },
    { label: 'EX', value: 'EX' },
]
//----------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------
/**
 * @EN OPTIONS TO RAIN
 * @ES OPCIONES PARA RAIN
 */
//----------------------------------------------------------------------------------------------------------------------------
export const rainOptions = [
    { label: '0 - No llueve', value: '0' },
    { label: '1 - Llueve suave', value: '1' },
    { label: '2 - Llueve fuerte', value: '2' },
    { label: '3 - Llueve muy fuerte', value: '3' },
    { label: '4 - Llueve extrema', value: '4' },
]
//----------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------
/**
 * @EN OPTIONS TO STATUS AERO
 * @ES OPCIONES PARA STATUS AERO
 */
//----------------------------------------------------------------------------------------------------------------------------
export const statusAeroOptions = [
    { label: 'Parada Anterior', value: 'Parada Anterior' },
    { label: 'Causa ajena al PVA', value: 'Causa ajena al PVA' },
]
//----------------------------------------------------------------------------------------------------------------------------
